import { useState, useEffect } from 'react';
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import { logout } from './api';
import Login from './pages/Login';
import Register from './pages/Register';
import Dashboard from './pages/Dashboard';
import Admin from './pages/AdminShell';
import PaymentSuccess from './pages/PaymentSuccess';
import ForgotPassword from './pages/ForgotPassword';
import ResetPassword from './pages/ResetPassword';

export default function App() {
  const [member, setMember] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const stored = localStorage.getItem('member');
    if (stored) {
      setMember(JSON.parse(stored));
    }
    setLoading(false);
  }, []);

  const handleLogin = (memberData) => {
    setMember(memberData);
  };

  const handleLogout = () => {
    logout().catch(() => {});
    localStorage.removeItem('member');
    setMember(null);
  };

  if (loading) return null;

  return (
    <BrowserRouter>
      <Routes>
        <Route
          path="/"
          element={
            member
              ? <Navigate to={member.is_admin ? '/admin' : '/dashboard'} />
              : <Login onLogin={handleLogin} />
          }
        />
        <Route
          path="/register"
          element={
            member
              ? <Navigate to="/dashboard" />
              : <Register onLogin={handleLogin} />
          }
        />
        <Route
          path="/dashboard"
          element={
            member
              ? <Dashboard member={member} onLogout={handleLogout} />
              : <Navigate to="/" />
          }
        />
        <Route
          path="/admin"
          element={
            member?.is_admin
              ? <Admin member={member} onLogout={handleLogout} />
              : <Navigate to="/" />
          }
        />
        <Route
          path="/payment-success"
          element={
            member
              ? <PaymentSuccess />
              : <Navigate to="/" />
          }
        />
        <Route path="/forgot-password" element={<ForgotPassword />} />
        <Route path="/reset-password" element={<ResetPassword />} />
      </Routes>
    </BrowserRouter>
  );
}